module.exports = __webpack_public_path__ + "img/emoticon_inchidere_cont.461a0a8c.svg";